<template>
  <v-container>
    <v-form lazy-validation ref="defaultDiscForm">
      <v-row>
        <v-col cols="6" sm="6" md="3" lg="3">
          <v-text-field
            v-model="defaultDiscount"
            type="number"
            outlined
            dense
            label="Default discount"
            append-outer-icon="mdi-percent"
            min="0"
            max="100"
            :rules="[rules.required, rules.amount]"
            color="accent"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" sm="6" md="3" lg="3">
          <v-btn
            :disabled="defaultDiscount === ''"
            color="success"
            class="white--text"
            @click="postDefaultDiscount"
          >
            Update discount
            <v-icon right dark> mdi-sale </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider></v-divider>
    <!-----------CREATING NEW BRAND FORM--------------------------------------->
    <v-form
      @submit.prevent="createBrandDiscPath"
      ref="createForm"
      lazy-validation
    >
      <v-dialog v-model="dialogCreate" width="50%" persistent>
        <v-card>
          <v-card-title class="headline footer" primary-title>
            {{ dialogText }}
          </v-card-title>
          <v-card-text class="pt-6">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  label="Brand name"
                  v-model="brandName"
                  type="text"
                  :rules="[rules.required]"
                  outlined
                  dense
                  :items="brands"
                  :item-text="'brandName'"
                  :item-value="'brandName'"
                  clearable
                  color="accent"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  label="Condition"
                  v-model="condition"
                  type="text"
                  :items="conditions"
                  :rules="
                    category === '' || category === undefined
                      ? []
                      : [rules.required]
                  "
                  outlined
                  dense
                  clearable
                  color="accent"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <TreeSelect
                  v-model="category"
                  placeholder="Category"
                  style="padding-top: 0px; margin-top: 0px; width: 100%"
                  :dropdown-style="{
                    maxHeight: '400px',
                    overflow: 'auto',
                  }"
                  :tree-data="categories"
                  :replaceFields="{
                    children: 'children',
                    title: 'name',
                    key: 'id',
                    value: 'path',
                  }"
                  filled
                  color="accent"
                >
                </TreeSelect>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Discount"
                  v-model="newDiscount"
                  type="number"
                  :rules="[rules.required, rules.amount]"
                  outlined
                  dense
                  min="0"
                  max="100"
                  clearable
                  color="accent"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeCreateDialog">
              Close
            </v-btn>
            <v-btn color="success" outlined @click="createBrandDiscPath">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!----------------------------------------------------------------------------->

    <!-----------MAIN CONTAINER---------------------------------------------------->
    <v-card v-if="!failed">
      <v-card-title class="footer basic--text headline">
        <v-row align="center">
          <v-col cols="3"> Discounts tree </v-col>

          <v-col>
            <v-btn @click="openCreateBrand" color="accent" outlined>
              Add new brand discount
              <v-icon right dark> mdi-sale </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <!-----------SEARCH BAR------------------------------------------------------->
      <v-sheet class="pa-4 footer">
        <v-text-field
          v-model="search"
          label="Search brand"
          dense
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>
      <!----------------------------------------------------------------------------->
      <v-row class="pa-4" justify="space-between">
        <!-----------LEFT TAB (DISCOUNTS TREE)------------------------------------------>
        <v-col cols="6">
          <v-row>
            <v-col class="ml-1 mb-2">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="toggleTreeview"
                    size="30"
                    >{{
                      expanded
                        ? "mdi-unfold-less-horizontal"
                        : "mdi-unfold-more-horizontal"
                    }}</v-icon
                  >
                </template>
                <span>Expand/Collapse all</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row style="max-height: 60vh; overflow: auto">
            <v-col>
              <v-treeview
                ref="mytreeview"
                :active.sync="active"
                :items="items"
                return-object
                activatable
                color="accent"
                transition
                :search="search"
                @update:active="setBrandInfo"
                dense
                :open-all="expanded"
              >
              </v-treeview>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-divider vertical></v-divider> -->
        <!-------------------------------------------------------------------------------------->

        <!-----------RIGHT TAB (INPUT DISCOUNT)-------------------------------------------------->
        <v-col cols="6" class="d-flex">
          <v-scroll-y-transition mode="out-in">
            <!-----------SHOW THIS DIV WHEN BRAND NOT SELECTED--------------------------------------->
            <div
              v-if="!selected"
              class="title grey--text text--lighten-1 font-weight-light"
              style="align-self: center"
            >
              Select a brand
            </div>
            <!-------------------------------------------------------------------------------------->
            <!-----------SHOW THIS DIV WHEN BRAND IS SELECTED--------------------------------------->
            <div v-else style="width: 100%">
              <v-form lazy-validation ref="discountForm">
                <v-row class="pt-2 mx-auto text-center">
                  <v-col cols="12">
                    <h3 class="headline mb-2 text-center basic--text">
                      {{ selected.path }}
                    </h3>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="pt-4">
                  <v-col cols="6">
                    <v-text-field
                      color="accent"
                      v-model="discount"
                      type="number"
                      outlined
                      dense
                      label="Discount"
                      append-outer-icon="mdi-percent"
                      min="0"
                      max="100"
                      @change="enableButton"
                      :rules="[rules.required, rules.amount]"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      :disabled="!enable"
                      color="success"
                      class="ma-2 white--text"
                      @click="putDiscount"
                    >
                      Update discount
                      <v-icon right dark> mdi-sale </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <!------------------------------------------------------------------------------------->
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
    <!----------------------------------------------------------------------------->

    <!-----------STATUS DIALOG----------------------------------------------------->
    <v-dialog v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        :textColor="textColor"
      >
      </status-info>
    </v-dialog>
    <!----------------------------------------------------------------------------->

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
      :pending="false"
      @close="reset"
    >
    </status-info>
    <!------------------------------------------------------------------------------->

    <!-------------------RED SNACKBAR, IF FORM IS FILLED INCORRECTLY----------------->
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!------------------------------------------------------------------------------->
  </v-container>
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";
import { TreeSelect } from "ant-design-vue";

export default {
  name: "Discounts",
  components: {
    StatusInfo,
    TreeSelect,
  },
  data: () => ({
    items: [],
    active: [],
    dialogCreate: false,
    dialogText: "",
    rules: {
      required: (value) => !!value || "Field is required.",
      amount: (value) => (value < 100 && value > 0) || "Amount must be valid",
    },
    responseMessage: "",
    filename: "",
    failed: false,
    search: null,
    statusDialog: false,
    defaultDiscount: "",
    brandName: "",
    pending: false,
    enable: false,
    selected: undefined,
    discount: "",
    path: "",
    conditions: ["Defected", "Not defected"],
    condition: "",
    newDiscount: "",
    categories: [],
    brands: [],
    category: undefined,
    filter: null,
    snackbar: false,
    snackbarText: "",
    textColor: "basic--text",
    expanded: false,
  }),
  watch: {
    condition(val) {
      if (val === null) {
        this.condition = "";
      }
    },
    category(val) {
      if (val === null) {
        this.category = undefined;
      }
    },
  },
  methods: {
    async toggleTreeview() {
      this.expanded = !this.expanded;
      this.$refs.mytreeview.updateAll(this.expanded);
    },
    closeStatusDialog() {
      this.statusDialog = false;
    },
    // getting brands tree from server
    fetchBrandsTree() {
      axios
        .get("api/discounts")
        .then((response) => {
          this.textColor = "basic--text";
          this.items = response.data;
        })
        .catch((error) => {
          this.textColor = "red--text";
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.failed = true;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    reset() {
      this.$router.go();
    },
    closeCreateDialog() {
      this.dialogCreate = false;
      this.$refs.createForm.reset();
      this.category = undefined;
    },
    openCreateBrand() {
      this.dialogText = "Create new brand";

      this.statusDialog = true;
      this.pending = true;

      let categories = "api/categories";
      let brands = "api/brands";

      const requestCategories = axios.get(categories);
      const requestBrands = axios.get(brands);
      if (this.categories.length == 0 || this.brands.length == 0) {
        axios
          .all([requestCategories, requestBrands])
          .then(
            axios.spread((...responses) => {
              this.textColor = "basic--text";
              const responseCategories = responses[0];
              const responseBrands = responses[1];

              this.categories = responseCategories.data;
              this.brands = responseBrands.data;

              this.statusDialog = false;
              this.pending = false;

              this.dialogCreate = true;
            })
          )
          .catch((error) => {
            this.textColor = "red--text";
            this.responseMessage = error.response.data;
            this.pending = false;
            if (error.response.data) {
              switch (error.response.status) {
                case 400:
                  this.filename = "empty.svg";
                  break;
                case 401:
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 403:
                  this.filename = "403_forbidden.svg";
                  break;
                case 404:
                  this.filename = "void.svg";
                  break;
                case 500:
                  this.filename = "server_down.svg";
              }
            } else {
              this.responseMessage = "Sorry... Something went wrong.";
              this.filename = "feeling_blue.svg";
            }
          });
      } else {
        this.statusDialog = false;
        this.pending = false;
        this.dialogCreate = true;
      }
    },
    createBrandDiscPath() {
      if (this.$refs.createForm.validate()) {
        this.dialogCreate = false;

        let path = `${this.brandName}`;

        if (this.condition != "") {
          path = path + `/${this.condition}`;
        }

        if (this.category != "" && this.category != undefined) {
          path = path + `/${this.category}`;
        }

        this.postNewBrandDisc(path);
      }
    },
    postNewBrandDisc(path) {
      this.pending = true;
      this.statusDialog = true;
      axios
        .post("api/discounts", {
          path: path,
          discount: this.newDiscount,
        })
        .then(() => {
          this.textColor = "basic--text";
          this.pending = false;
          this.responseMessage = `Success! Brand ${this.brandName} created with discount ${this.newDiscount}%!`;
          this.filename = "high_five.svg";
          this.fetchBrandsTree();
          this.$refs.createForm.reset();
          this.category = undefined;
        })
        .catch((error) => {
          this.pending = false;
          this.textColor = "red--text";
          if (error.response.status) {
            this.responseMessage = error.response.data;
            switch (error.response.status) {
              case 400:
                this.filename = "empty.svg";
                break;
              case 401:
                //clear local storage, push to login
                localStorage.clear();
                this.$router.push("login");
                break;
              case 403:
                this.filename = "403_forbidden.svg";
                break;
              case 500:
                this.filename = "server_down.svg";
            }
          } else {
            this.filename = "feeling_blue.svg";
            this.responseMessage = "Something went wrong...!";
          }
        });
    },
    putDiscount() {
      if (this.$refs.discountForm.validate()) {
        this.pending = true;
        this.statusDialog = true;
        axios
          .put("api/discounts", {
            path: this.path,
            discount: this.discount,
          })
          .then(() => {
            this.textColor = "basic--text";
            this.pending = false;
            this.responseMessage = `Success! Discount updated to ${this.discount}!`;
            this.filename = "high_five.svg";
            this.fetchBrandsTree();
          })
          .catch((error) => {
            this.textColor = "red--text";
            this.pending = false;
            if (error.response.status) {
              switch (error.response.status) {
                case 400:
                  this.filename = "empty.svg";
                  this.responseMessage =
                    "Sorry, something went wrong, please contact TECH team!";
                  break;
                case 401:
                  //clear local storage, push to login
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 403:
                  this.filename = "403_forbidden.svg";
                  this.responseMessage =
                    "Sorry, you are forbidden to do this action!";
                  break;
                case 500:
                  this.filename = "server_down.svg";
                  this.responseMessage =
                    "Internal server error, please contact TECH team!";
              }
            } else {
              this.filename = "feeling_blue.svg";
              this.responseMessage = "Something went wrong...!";
            }
          });
      }
    },
    setBrandInfo() {
      this.selected = undefined;
      this.enable = false;
      if (!this.active[0] != undefined) {
        this.discount = this.active[0].discount;
        this.path = this.active[0].path;
        this.selected = this.active[0];
      }
    },
    enableButton() {
      this.enable = true;
    },
    setDefaultDiscount() {},
    postDefaultDiscount() {
      if (this.$refs.defaultDiscForm.validate()) {
        this.pending = true;
        this.statusDialog = true;
        axios
          .post("api/discounts/default", {
            defaultDiscount: this.defaultDiscount,
          })
          .then(() => {
            this.textColor = "basic--text";
            this.pending = false;
            this.responseMessage = `Success! Default discount set to ${this.defaultDiscount}.`;
            this.filename = "high_five.svg";
          })
          .catch((error) => {
            this.textColor = "red--text";
            this.pending = false;
            if (error.response.status) {
              switch (error.response.status) {
                case 400:
                  this.responseMessage =
                    "Sorry, something went wrong, please contact TECH team!";
                  this.filename = "empty.svg";
                  break;
                case 401:
                  //clear local storage, push to login
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 406:
                  //clear local storage, push to login
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 403:
                  this.responseMessage =
                    "Sorry, you are forbidden to do this action!";
                  this.filename = "403_forbidden.svg";
                  break;
                case 500:
                  this.responseMessage =
                    "Internal server error, please contact TECH team!";
                  this.filename = "server_down.svg";
              }
            } else {
              this.responseMessage = "Sorry... Something went wrong...";
              this.filename = "feeling_blue.svg";
            }
          });
      }
    },
    getDefaultDiscount() {
      axios
        .get("api/discounts/default")
        .then((response) => {
          this.textColor = "basic--text";
          this.defaultDiscount = response.data.DefaultDiscount;
        })
        .catch((error) => {
          this.textColor = "red--text";
          console.log(error);
        });
    },
  },
  mounted() {
    this.fetchBrandsTree();
    this.getDefaultDiscount();
  },
};
</script>